import { styled, css } from "styled-components";

export const StyledGraphContainer = styled.div`
  display: flex;
  width: 100%;
  height: 64px;
`;

export const StyledOvuGroupBox = styled.div<{ $barCount: number }>`
  display: flex;
  flex-direction: column;
  flex: ${({ $barCount }) => $barCount};
  min-width: 0;
`;

export const StyledOvuBarBox = styled.div<{
  $isFirst: boolean;
  $isLast: boolean;
}>`
  display: flex;
  flex: 1;
  align-items: flex-end;
  gap: 2px;
  margin-bottom: 2px;
  padding: 0 2px;
  border-right: 1px dashed rgba(255, 255, 255, 0.2);

  ${({ $isFirst }) =>
    $isFirst &&
    css`
      padding-left: 0px;
    `}

  ${({ $isLast }) =>
    $isLast &&
    css`
      border-right: none;
      padding-right: 0px;
    `}
`;

export const StyledOvuBarItem = styled.div<{
  $height: number;
  $isSelect: boolean;
}>`
  flex: 1;
  height: ${({ $height }) => `${$height}%`};
  background-color: ${({ $isSelect }) => ($isSelect ? "#FFDB39" : "#d9d9d9")};
  border-radius: 2px 2px 0 0;
`;
